module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-zip-adb88d9f6fd85948c97da09f81fd02fd.svg";